import React from "react";
import { Box, Fade, Grid, Typography, useTheme } from "@mui/material";
import SpecialCard from "../card/SpecialCard";

import { ReactComponent as EnlargeKnowledge } from "../../resources/images/svg/home/enlargeYourKnowledge.svg";
import { ReactComponent as FindSupport } from "../../resources/images/svg/home/findSupport.svg";
import { ReactComponent as DevelopAlliances } from "../../resources/images/svg/home/developAlliances.svg";
import { ReactComponent as GetALabel } from "../../resources/images/svg/home/getALabel.svg";
import useIsOnScreen from "../../hooks/useIsOnScreen";

const HeroCard = ({
  index = 0,
  icon,
  title,
  cardProps = {},
  textSx = {},
  ...props
}) => {
  const ref = React.useRef(null);
  const isVisible = useIsOnScreen(ref);
  return (
    <Grid
      ref={ref}
      xs={6}
      md={4}
      sx={{
        width: { xs: "100%", sm: "22%" },
      }}
    >
      <Fade in={isVisible} timeout={index * 500}>
        <Box>
          <SpecialCard {...cardProps}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                position: "relative",
              }}
            >
              {icon}
              <Typography
                sx={{
                  mt: 1.5,
                  fontSize: "20px",
                  fontFamily: "Branding Bold",
                  fontWeight: "semibold",
                  ...textSx,
                }}
              >
                {title}
              </Typography>
            </Box>
          </SpecialCard>
        </Box>
      </Fade>
    </Grid>
  );
};

const HomeHeroCards = (props) => {
  const theme = useTheme();

  return (
    <Grid
      container
      spacing={5}
      {...props}
      sx={{
        ...props.sx,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "5vw",
        marginLeft: "5vw",
      }}
    >
      <HeroCard
        index={0}
        icon={<EnlargeKnowledge width={"62px"} height={"62px"} />}
        title={(<>
          <b style={{ fontWeight: 700}}>Élargissez vos connaissances </b> 
          grâce à nos podcasts
        </>)}
      />
      <HeroCard
        index={1}
        icon={<FindSupport width={"62px"} height={"62px"} />}
        title={(<>
          <b style={{ fontWeight: 700}}>Trouvez du soutien </b>
          à travers nos ressources et nos rencontres
        </>)}
      />
      <HeroCard
        index={2}
        icon={<DevelopAlliances width={"62px"} height={"62px"} />}
        title={(<>
          <b style={{ fontWeight: 700}}>Grandissez dans votre pratique </b>
          avec nos événements
        </>)}
      />
      <HeroCard
        index={3}
        icon={
          <>
            <GetALabel
              width={"157px"}
              height={"147px"}
              style={{
                position: "absolute",
                top: -40,
                left: -25,
              }}
            />
            <DevelopAlliances
              width={"62px"}
              height={"62px"}
              style={{
                opacity: 0,
              }}
            />
          </>
        }
        title={(<>
          <b style={{ fontWeight: 700}}>Développez votre visibilité et crédibilité </b>
          grâce à notre label
        </>)}
        cardProps={{
          backgroundColor: theme.palette.blackPro,
        }}
        textSx={{
          color: "white",
        }}
      />
    </Grid>
  );
};

export default HomeHeroCards;
